import axios from "axios";
import { config } from "@/config/constants.js";
import router from "@/router/index.js";
import jsonToFormData from "@ajoelp/json-to-formdata";
export default {
  namespaced: true,
  state: {
    status: "",
    forgot_status: "",
    token: localStorage.getItem(config.token_key) || "",
    user_role: localStorage.getItem(config.role_key) || "",
    user: {},
    address: [],
  },
  mutations: {
    setAddresses(state, list) {
      state.addresses = [];
      for (const address of list) {
          state.addresses.push(address);
          state.addresses.sort((a, b) => (a.is_main < b.is_main) ? 1 : -1);
      }
    },
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, data) {
      state.status = "success";

      if (data && data["token"]) {
        state.token = data.token;
        axios.defaults.headers.common["access-token"] = state.token;
        localStorage.setItem(config.token_key, state.token);
      }

      if (data && data["user"]) {
        state.user = data.user;
      }
    },
    forgot_status(state, data) {
      state.forgot_status = data;
    },
    auth_error(state) {
      state.status = "error";
      localStorage.removeItem(config.token_key);
      axios.defaults.headers.common["access_token"] = state.token = "";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = {};
      localStorage.removeItem(config.token_key);
      axios.defaults.headers.common["access-token"] = state.token = "";
    },
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .post(config.api_url + "login", user)
          .then((response) => {
            commit("auth_success", {
              user_role: response.data.user_role,
              token: response.data.access_token,
              user: response.data
            });
            resolve(response.data);
          })
          .catch((err) => {
            console.log(err);
            commit("auth_error");
            reject(err.response.data);
          });
      });
    },
    forgot_password({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("forgot_status", "loading");
        axios
          .post(config.api_url + "forgot_password", user)
          .then((response) => {
            commit("forgot_status", "complete");
            resolve(response.data);
          })
          .catch((err) => {
            console.log(err);
            commit("forgot_status", "error");
            reject(err.response.data);
          });
      });
    },
    change_password({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("forgot_status", "loading");
        axios
            .post(config.api_url + "change_password", user)
            .then((response) => {
              commit("forgot_status", "complete");
              resolve(response.data);
            })
            .catch((err) => {
              console.log(err);
              commit("forgot_status", "error");
              reject(err.response.data);
            });
      });
    },
    reset_forgot_password({ commit }) {
      return new Promise((resolve) => {
        commit("forgot_status", "");
        resolve();
      });
    },
    logout({ commit }) {
      commit("logout");
      if (router.currentRoute.path !== "/") {
        router.push("/");
      }
    },
    me({ commit }) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .get(config.api_url + "me")
          .then((response) => {
            commit("auth_success", { user: response.data });
            resolve(response.data);
          })
          .catch((err) => {
            console.log(err);
            commit("auth_error");
            reject(err);
          });
      });
    },
    register({ commit }, user) {
      let auth = true;
      if (user.auth === false) auth = user.auth;
      return new Promise((resolve, reject) => {
        commit("auth_request");
        const formData = jsonToFormData(user, {
          arrayIndexes: true,
          excludeNull: true
        });
        axios
          .post(config.api_url + "register", formData)
          .then(response => {
            if (auth)
              commit("auth_success", {
                token: response.data.access_token,
                user: response.data
              });
            resolve(response.data);
          })
          .catch(err => {
            commit("auth_error");
            reject(err.response.data);
          });
      });
    },
    contact({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .post(config.api_url + "contact", user)
          .then(response => {
            commit("auth_success", {
              token: response.data.access_token,
              user: response.data
            });
            resolve(response.data);
          })
          .catch(err => {
            commit("auth_error");
            reject(err.response.data);
          });
      });
    },
    comment({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .post(config.api_url + "comment", user)
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
            commit("auth_error");
            reject(err.response.data);
          });
      });
    },
    video_comment({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .post(config.api_url + "video/comment", user)
          .then(response => {
            commit("auth_success", {
              //token: response.data.access_token,
              //user: response.data
            });
            resolve(response.data);
          })
          .catch(err => {
            commit("auth_error");
            reject(err.response.data);
          });
      });
    },
    authenticate_google({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .post(config.api_url + "authentication_google", user)
          .then(response => {
            commit("auth_success", {

            });
            resolve(response.data);
          })
          .catch(err => {
            commit("auth_error");
            reject(err.response.data);
          });
      });
    },
    add_event_google_calendar({ commit }, date) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .post(config.api_url + "add_event_google_calendar", date)
          .then(response => {
            commit("auth_success", {

            });
            resolve(response.data);
          })
          .catch(err => {
            commit("auth_error");
            reject(err.response.data);
          });
      });
    },
    deleteMyAccount({ commit }, date) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
            .delete(config.api_url + "delete_account")
            .then(response => {
              commit("logout");
              if (router.currentRoute.path !== "/") {
                router.push("/");
              }
              resolve(response.data);
            })
            .catch(err => {
              commit("auth_error");
              reject(err.response.data);
            });
      });
    },
    add_address({commit}, params) {
      return new Promise((resolve, reject) => {
          axios
              .post(config.api_url + "add_address", params)
              .then(response => {
                  commit('setAddresses', response.data.addresses);
                  resolve(response.data);
              })
              .catch(err => {
                  reject(err.response.data);
              });
      });
    },
    edit_address({commit}, params) {
        return new Promise((resolve, reject) => {
            params = {
                ...params,
                address_id: params.id
            };
            axios
                .post(config.api_url + "add_address", params)
                .then(response => { 
                    commit('setAddresses', response.data.addresses);
                    resolve(response.data);
                })
                .catch(err => {
                    reject(err.response.data);
                });
        });
    },
    edit_user({ commit }, data) {
      return new Promise((resolve, reject) => {
        const formData = jsonToFormData(data, {
          arrayIndexes: true,
          excludeNull: true
        });
        axios
          .put(config.api_url + "edit_profile", formData)
          .then(response => {
            if (response.data.access_token) {
              commit("auth_success", {
                token: response.data.access_token,
                user: response.data
              });
            }

            resolve(response.data);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },
    get_address({commit}, params) {
      return new Promise((resolve, reject) => {
          params = {
              ...params,
              address_id: params.id
          };
          axios
              .get(config.api_url + "get_address", params)
              .then(response => { 
                  commit('setAddresses', response.data);
                  resolve(response.data);
              })
              .catch(err => {
                  reject(err.response.data);
              });
      });
    },
    remove_address({commit}, params) {
      return new Promise((resolve, reject) => {
          axios
              .post(config.api_url + "delete_address", params)
              .then(response => {
                  commit('setAddresses', response.data.addresses);
                  resolve(response.data);
              })
              .catch(err => {
                  reject(err.response.data);
              });
      });
    },
    verify_code({commit}, data) {
      return new Promise((resolve, reject) => {
          axios
              .post(config.api_url + "verify_code", data)
              .then(response => {
                  //commit('setAddresses', response.data.addresses);
                  resolve(response.data);
              })
              .catch(err => {
                  reject(err.response.data);
              });
      });
    },
  },
  getters: {
    isLoggedIn(state) {
      return state.token && state.token != undefined;
    },
    check_permission(state) {
      return (
        state.user &&
        ["sadmin", "admin", undefined].includes(state.user["role"])
      );
    },
    can_edit(state) {
      return function (section) {
        if (["projects"].includes(section)) {
          return (
            state.user &&
            state.user.role &&
            ["sadmin", "admin", "pm"].includes(state.user.role)
          );
        }

        return false;
      };
    },
  },
  modules: {},
};
